/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Permutationhour1Inputs */



/**
* | output |
* | --- |
* | "Permutation hour" |
*
* @param {Br_History_Key_Permutationhour1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_permutationhour1 = /** @type {((inputs?: Br_History_Key_Permutationhour1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Permutationhour1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Permutation hour")
	return /** @type {LocalizedString} */ ("Heure de permutation")
});
export { br_history_key_permutationhour1 as "br_history_key_permutationHour" }